import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const PRIMARY_COLOR = '#4C52AD';
const SECONDARY_COLOR = '#666';

const styles = StyleSheet.create({
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 20,
        right: 20,
        paddingTop: 10,
        borderTop: `1px solid ${PRIMARY_COLOR}`,
        fontSize: 9,
        textAlign: 'center',
    },
    thankYou: {
        color: PRIMARY_COLOR,
        fontWeight: 'bold',
        marginBottom: 4,
    },
    appreciation: {
        color: SECONDARY_COLOR,
        fontSize: 8,
        marginBottom: 6,
    },
    contactInfo: {
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 15,
        marginBottom: 6,
    },
    copyright: {
        fontSize: 8,
        color: SECONDARY_COLOR,
    },
    decorativeLine: {
        height: 1,
        backgroundColor: PRIMARY_COLOR,
        marginBottom: 8,
        width: '50%',
        alignSelf: 'center',
    }
});

const PDFFooter = ({ hotelName, contactEmail, contactPhone }) => (
    <View style={styles.footer} fixed>
        <View style={styles.decorativeLine} />
        <Text style={styles.thankYou}>Thank you for choosing {hotelName}!</Text>
        <Text style={styles.appreciation}>We appreciate your business and hope to serve you again soon</Text>
        <View style={styles.contactInfo}>
            <Text>{contactEmail}</Text>
            <Text>|</Text>
            <Text>{contactPhone}</Text>
        </View>
        <Text style={styles.copyright}>© {new Date().getFullYear()} {hotelName}. All rights reserved.</Text>
    </View>
);

export default PDFFooter;